// @flow
import { call, takeEvery, put } from 'redux-saga/effects';
import { type Saga } from 'redux-saga';
import { makeGetRequest, makePostRequest } from 'services/request/request';
// import { fetchMachine } from './actions';
import { setCurrentSavingStatus } from 'redux/PendingStatus/actions';
import {
  fetchMachineSuccess,
  addMachineSuccess,
  fetchServerStatusesSuccess,
  fetchNoOfRequestSuccess,
  fetchAllLogsSuccess,
  fetchAlertLogsSuccess,
  fetchBillingDetailsSuccess,
  fetchAuctionDetailsSuccess,
  fetchCardDetailsSuccess,
  fetchReportsSuccess,
  fetchCardSwapLogsSuccess,
  fetchCardSwapLogsFailure,
} from './actions';
import {
  ADD_MACHINE_REQUEST,
  ALERT_LOGS_REQUEST,
  ALL_LOGS_REQUEST,
  NO_OF_REQUEST,
  SERVER_STATUS_REQUEST,
  AUCTION_DETAILS_REQUEST,
  BILLING_DETAILS_REQUEST,
  CARD_DETAILS_REQUEST,
  MACHINES_REQUEST,
  REPORTS_REQUEST,
  FETCH_CARD_SWAP_LOGS_REQUEST,
} from '.';

export function* fetchMachineRequest(): Saga<*> {
  try {
    // yield put(setCurrentSavingStatus('pending'));
    const response = yield call(makeGetRequest, `/machines`, null);
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      yield put(fetchMachineSuccess(response.body));
      // yield put(fetchMachine(response));
    }
  } catch (error) {
    // yield put(setCurrentSavingStatus('failed'));
  }
}

export function* addMachineRequest(machinePayload: any): Saga<*> {
  try {
    const {
      payload: { machine },
    } = machinePayload;
    const response = yield call(makePostRequest, `/machines`, machine);
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      yield put(addMachineSuccess(response.body));
      // yield put(fetchMachine(response));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* fetchServerStatusesRequest(): Saga<*> {
  try {
    let logs = {};
    let response = yield call(makeGetRequest, `/logs/server-status`, {});
    if (response && response.statusCode === 200) {
      logs = {
        serverStatuses: response.body.map((value) => value.count),
      };
      response = yield call(makeGetRequest, `/logs/server-status`, {
        type: 'nas',
      });
      logs = {
        ...logs,
        nasServerStatuses: response.body.map((value) => value.count),
      };

      response = yield call(makeGetRequest, `/logs/server-status`, {
        type: 'camera',
      });
      logs = {
        ...logs,
        cameraServerStatuses: response.body.map((value) => value.count),
      };
      response = yield call(makeGetRequest, `/logs/server-status`, {
        type: 'network-switch',
      });
      logs = {
        ...logs,
        networkSwitchServerStatuses: response.body.map((value) => value.count),
      };
      response = yield call(makeGetRequest, `/logs/server-status`, {
        type: 'server-work-station',
      });
      logs = {
        ...logs,
        serverWorkStationServerStatuses: response.body.map((value) => value.count),
      };
      yield put(fetchServerStatusesSuccess(logs));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* fetchNoOfRequestSaga(): Saga<*> {
  const logs = {};
  try {
    let response = yield call(makeGetRequest, `/logs/aggregate`, {
      filter: JSON.stringify({
        where: {
          state: 'available',
        },
      }),
    });
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      logs.noOfRequest = response.body;
    }

    response = yield call(makeGetRequest, `/logs/aggregate`, {
      filter: JSON.stringify({
        where: {
          state: 'disrupt',
        },
      }),
    });
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      logs.disrupt = response.body;
    }
    response = yield call(makeGetRequest, `/logs/aggregate`, {
      filter: JSON.stringify({
        where: {
          state: 'outage',
        },
      }),
    });
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      logs.outage = response.body;
    }
    yield put(fetchNoOfRequestSuccess(logs));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchAllLogsRequestSaga(payload: any): Saga<*> {
  let logs = [];
  const {
    payload: { logType, lotNumber },
  } = payload;
  try {
    const response = yield call(makeGetRequest, `/cards-activity`, {
      limit: 50,
      type: logType,
      lotNumber,
    });
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      logs = response.body;
    }
    yield put(fetchAllLogsSuccess(logs));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchBillingDetailsRequestSaga(): Saga<*> {
  try {
    let billingDetails = [];
    const response = yield call(makeGetRequest, `/stats`);
    if (response && response.statusCode === 200) {
      billingDetails = response.body;
    }
    yield put(fetchBillingDetailsSuccess(billingDetails));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchAuctionDetailsRequestSaga(): Saga<*> {
  try {
    let auctionDetails = [];
    const response = yield call(makeGetRequest, `/auction-details`, {
      limit: 50,
    });
    if (response && response.statusCode === 200) {
      auctionDetails = response.body;
    }
    yield put(fetchAuctionDetailsSuccess(auctionDetails));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchCardDetailsRequestSaga(): Saga<*> {
  try {
    let cardDetails = [];
    const response = yield call(makeGetRequest, `/card-details`, {
      limit: 50,
    });
    if (response && response.statusCode === 200) {
      cardDetails = response.body;
    }
    yield put(fetchCardDetailsSuccess(cardDetails));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchAlertLogsRequestSaga(): Saga<*> {
  let logs = [];
  try {
    const response = yield call(makeGetRequest, `/logs/alert`, {});
    if (response && response.statusCode === 200) {
      // yield put(setCurrentSavingStatus('done'));
      logs = response.body;
    }
    yield put(fetchAlertLogsSuccess(logs));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function* fetchReportsRequestSaga(request: any): Saga<*> {
  let logs = [];
  try {
    const {
      payload: { filter },
    } = request;
    yield put(setCurrentSavingStatus('pending'));
    const response = yield call(makeGetRequest, `/reports`, filter);
    if (response && response.statusCode === 200) {
      yield put(setCurrentSavingStatus('done'));
      logs = response.body;
    }
    yield put(fetchReportsSuccess(logs));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setCurrentSavingStatus('done'));
  }
}

export function* fetchCardSwapLogsRequestSaga(): Saga<*> {
  try {
    yield put(setCurrentSavingStatus('pending'));
    const response = yield call(makeGetRequest, `/card-swap-logs`, {});

    if (response && response.statusCode === 200) {
      yield put(setCurrentSavingStatus('success'));
      const logs = response.body;
      yield put(fetchCardSwapLogsSuccess(logs));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(fetchCardSwapLogsFailure());
    yield put(setCurrentSavingStatus('failed'));
  }
}

export default function* accountSagas(): Saga<*> {
  yield takeEvery(MACHINES_REQUEST, fetchMachineRequest);
  yield takeEvery(ADD_MACHINE_REQUEST, addMachineRequest);
  yield takeEvery(SERVER_STATUS_REQUEST, fetchServerStatusesRequest);
  yield takeEvery(NO_OF_REQUEST, fetchNoOfRequestSaga);
  yield takeEvery(ALL_LOGS_REQUEST, fetchAllLogsRequestSaga);
  yield takeEvery(ALERT_LOGS_REQUEST, fetchAlertLogsRequestSaga);
  yield takeEvery(BILLING_DETAILS_REQUEST, fetchBillingDetailsRequestSaga);
  yield takeEvery(AUCTION_DETAILS_REQUEST, fetchAuctionDetailsRequestSaga);
  yield takeEvery(CARD_DETAILS_REQUEST, fetchCardDetailsRequestSaga);
  yield takeEvery(REPORTS_REQUEST, fetchReportsRequestSaga);
  yield takeEvery(FETCH_CARD_SWAP_LOGS_REQUEST, fetchCardSwapLogsRequestSaga);
}
